import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  ArrowLeftOutlined,
  HomeOutlined,
  SearchOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  Dropdown,
  Badge,
  Tooltip,
  Breadcrumb,
  Modal,
  Form,
  Input,
  Select,
  Button,
} from "antd";
import { Images } from "../Controller";
import { Menuitems } from "./Menuitems";
import { persistor } from "../Store/Store";
import { RxDashboard } from "react-icons/rx";
import { IoIosArrowDown } from "react-icons/io";
import {
  GetDashboardData,
  GetWalletBalance,
  MemberProfile,
  UserLogout,
  getMemberServices,
  moneyTranferToMainWallet,
  verifyPinforReLogin,
} from "../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeft, BsArrowRight, BsBell } from "react-icons/bs";
import { AiOutlineWallet } from "react-icons/ai";
import NotificationDrawer from "./NotificationDrawer";
import { ThemeColor } from "../Theme/theme";
import { CiWallet } from "react-icons/ci";
import {
  clearAllRedux,
  setAEPSWalletBal,
  setCommissionWalletBal,
  setMemberService,
  setProfile,
  setWalletBal,
  setWalletType,
  setselectedTab,
} from "../Store/B2bslice";
import {
  dispatchtoast,
  getLocalStorageItem,
  setLocalStorageItem,
  trimString,
} from "../Utils";
import useOtpHook from "../Hooks/useOtpHook";
import Marquee from "react-fast-marquee";
import { BiRefresh, BiWallet } from "react-icons/bi";
import DashboardCommon from "../Views/Main/Dashboard/DashboardCommon";
import { useForm } from "antd/es/form/Form";
const { Header, Sider, Content } = Layout;
const AUTO_LOGOUT_TIME = 15 * 60 * 1000;
const ProjectLayout = ({ children }) => {
  const [form] = useForm();
  const timerRef = useRef(null);
  const [collapsed, setCollapsed] = useState(false);
  const [windowwidth, setwindowwidth] = useState(window.innerWidth);
  const [showDefault, setShowDefault] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [open, setOpen] = useState(false);
  const [news, setNews] = useState([]);
  const [BtnLoading, setBtnLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const walletBalance = useSelector((state) => state.B2B.walletBal);
  const aepswalletBalance = useSelector((state) => state.B2B.aepswalletBal);
  const commissionwalletBalance = useSelector(
    (state) => state.B2B.commissionwalletBal,
  );
  const heading = useSelector((state) => state.B2B.heading);
  const subHeading = useSelector((state) => state.B2B.subHeading);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedTab = useSelector((state) => state.B2B.selectedTab);
  const [transferType, setTranferType] = useState("");
  const [openReVerifyPin, setOpenReVerifyPin] = useState(false);
  const { handleChange, handleKeyUp, pin, inputRefs, resetPin } = useOtpHook(4);
  const [spinState, setSpinState] = useState(false);
  const resetTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      console.log("⏰ Idle timeout → open modal");
      setLocalStorageItem("ActiveFlag", 0);
      setOpenReVerifyPin(true);
    }, AUTO_LOGOUT_TIME);
  }, []);

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);

      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [resetTimer]);
  useEffect(() => {
    getLocalStorageItem("ActiveFlag") === 0
      ? setOpenReVerifyPin(true)
      : setOpenReVerifyPin(false);
  });
  const handleVerify = () => {
    setModalLoading(true);
    const formdata = new FormData();
    formdata.append("mpin", pin.join(""));
    verifyPinforReLogin(formdata)
      .then((res) => {
        if (res.status) {
          setOpenReVerifyPin(false);
          setLocalStorageItem("ActiveFlag", 1);
          resetPin();
          dispatchtoast(res.message);
          navigate("/dashboard", { state: { allow: true } });
          MemberProfile()
            .then((res) => {
              if (res.status) {
                dispatch(setProfile(res.data.profile));
              } else {
                dispatchtoast("Unable to fetch profile detail", true);
              }
            })
            .catch((err) => console.log(err, "errr"));
        } else {
          dispatchtoast(res.message, true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setModalLoading(false));
  };
  useEffect(() => {
    const handleResize = () => {
      setwindowwidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    // setselectedTab(getLocalStorageItem("selectedTab"));
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {}, [selectedTab]);
  useEffect(() => {
    if (windowwidth > 1000) {
      setCollapsed(false);
      setShowDefault(true);
    } else {
      setCollapsed(true);
      setShowDefault(false);
    }
  }, [windowwidth]);

  const handleLogout = () => {
    UserLogout()
      .then((res) => {
        persistor.purge(); // This clears the persisted state
        dispatch(clearAllRedux());
        localStorage.clear();
        navigate("/");
        setTranferType("");
      })
      .catch((err) => console.log(err));
  };
  const handleTransfer = (val) => {
    console.log(val, "val");
    const formdata = new FormData();
    formdata.append("amount", val.amount);
    formdata.append("transfer_from", transferType);
    formdata.append("pin", val.pin);
    setBtnLoading(true);
    moneyTranferToMainWallet(formdata)
      .then((res) => {
        form.resetFields();
        setTranferType("");
        setOpen(false);
        setBtnLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setBtnLoading(false);
        setTranferType("");
      });
  };
  const walletItems = [
    {
      key: "1",
      label: (
        <div>
          <p className="font-medium mb-1 text-rgbaprimary7">AEPS Wallet Bal.</p>
          <p className="font-normal mb-2 text-rgbaprimary7">
            ₹ {aepswalletBalance}
          </p>
          <hr />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div>
          <p className="font-medium mb-1 text-rgbaprimary7">
            Commission Wallet Bal.
          </p>
          <p className="font-normal mb-2 text-rgbaprimary7">
            ₹ {commissionwalletBalance}
          </p>
          <hr />
        </div>
      ),
    },
  ];

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <div className="w-48">
    //       <div className="text-sm flex justify-start items-center">
    //         <AiOutlineWallet size={20} className="mr-3 text-sm text-rgbaprimary7" />
    //         <p> Wallet Balance</p>
    //       </div>
    //       <p className="font-bold text-[16px] mb-4 text-rgbaprimary7">Rs. {walletBalance}</p>
    //       <hr />
    //     </div>
    //   ),
    // },
    {
      key: "2",
      label: (
        <>
          <p
            onClick={() => navigate("/personal-info")}
            className="font-medium mb-4 text-rgbaprimary7"
          >
            View Profile
          </p>
          <hr />
        </>
      ),
    },
    {
      key: "3",
      label: (
        <p onClick={handleLogout} className="font-medium text-rgbaprimary7">
          Sign Out
        </p>
        //        <Popconfirm
        //    title="Logout"
        //    icon={<QuestionCircleOutlined />}
        //    description="Are you sure to logout?"
        //    onConfirm={()=>{}}
        //    onCancel={()=>{}}
        //    cancelButtonProps={{style:{color:"black"}}}
        //    okButtonProps={{style:{color:"white",background:"red"}}}
        //    okText="Yes"
        //    cancelText="No"
        //  >

        //       </Popconfirm>
      ),
    },
  ];

  const getNews = () => {
    GetDashboardData()
      .then((res) => {
        setNews(res.news);
      })
      .catch((err) => console.log(err));
  };
  const FetchwalletBalance = () => {
    setSpinState(true);
    GetWalletBalance()
      .then((res) => {
        if (res.status) {
          dispatch(setWalletBal(res.balance));
          dispatch(setAEPSWalletBal(res.aeps_wallet_balance));
          dispatch(setCommissionWalletBal(res.commission_wallet_balance));
          dispatch(setWalletType(res.wallet_types));
          setSpinState(false);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    FetchwalletBalance();
  }, []);
  useEffect(() => {
    getNews();
    MemberProfile()
      .then((res) => {
        if (res.status) {
          dispatch(setProfile(res.data.profile));
        } else {
          dispatchtoast("Unable to fetch profile detail", true);
        }
      })
      .catch((err) => console.log(err, "errr"));

    getMemberServices()
      .then((res) => {
        if (res.status) {
          dispatch(setMemberService(res.services));
        }
      })
      .catch((err) => console.log(err));
  }, [selectedTab]);
  return (
    <>
      <Layout hasSider className="min-h-screen sidebar">
        <Sider
          style={{
            position: "fixed",
            marginBottom: "20px",
            overflowY: "scroll",
            height: "100vh",
          }}
          trigger={null}
          collapsible
          className="my-10"
          collapsed={collapsed}
        >
          <div className="demo-logo-vertical flex justify-around items-center my-5">
            {!collapsed ? (
              <>
                <div className="flex gap-4 justify-start items-center">
                  {" "}
                  <img
                    src={Images.WebsiteLogo}
                    className="h-14 w-[90%] ml-2 rounded-md"
                    alt="Weblogo"
                  />
                </div>
                <RxDashboard
                  className="h-7 w-7 text-rgbaprimary7 cursor-pointer"
                  onClick={() => setCollapsed(!collapsed)}
                />
                {/* <img
                  onClick={() => setCollapsed(!collapsed)}
                  className="cursor-pointer"
                  src={Images.hamburger}
                  alt="logo"
                  width={30}
                  height={30}
                /> */}
              </>
            ) : (
              <img
                src={Images.WebsiteSmallLogo}
                alt="WeblogoSmall"
                className="h-6 w-10"
              />
            )}
          </div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["1"]}
            selectedKeys={[selectedTab]}
            items={Menuitems()}
          />
        </Sider>
        <Layout className="w-full">
          <Header
            style={{
              marginLeft: collapsed ? 75 : 230,
              // background:"linear-gradient(169deg, rgb(245, 14, 14) 0%, rgb(255 255 255) 0%, rgb(33, 111, 242) 100%, rgb(227, 9, 9) 100%)"
            }}
            className=" bg-white mt-4 flex justify-between items-center h-20"
          >
            <div className=" flex flex-wrap justify-start gap-x-3 mx-4  items-center">
              {collapsed ? (
                <p>
                  {" "}
                  <BsArrowRight
                    size={30}
                    onClick={() => setCollapsed(!collapsed)}
                    className="text-primary cursor-pointer"
                  />
                </p>
              ) : (
                ""
              )}
            </div>
            <div className=" flex flex-wrap justify-start gap-x-4 mx-4  items-center">
              {profiledetail.member_type !== "State Head" && (
                <div className="rounded-md  flex items-center">
                  <CiWallet className="h-7 w-7 text-rgbaprimary7 font-normal" />
                  <div className="outline-none border-none px-2 text-xs  py-2 rounded-md">
                    <div className="flex gap-4">
                      {" "}
                      <div>
                        <p className=" font-bold text-base text-rgbaprimary7">
                          ₹ {walletBalance}
                        </p>
                        <p className=" font-semibold text-rgbaprimary7">
                          Available Balance
                        </p>
                      </div>
                      <BiRefresh
                        onClick={FetchwalletBalance}
                        className={`${spinState ? "animate-spin text-primary" : ""}`}
                        size={28}
                      />
                    </div>
                  </div>
                </div>
              )}
              {profiledetail.member_type !== "State Head" &&
                profiledetail.member_type_id !== "2" &&
                profiledetail.member_type_id !== "3" && (
                  <div
                    className="rounded-md  flex items-center"
                    onClick={() => {
                      setOpen(true);
                      setTranferType("aeps_wallet");
                    }}
                  >
                    <CiWallet className="h-7 w-7 text-rgbaprimary7 font-normal" />
                    <div className="outline-none border-none px-2 text-xs  py-2 rounded-md">
                      <p className=" font-bold text-base text-rgbaprimary7">
                        ₹ {aepswalletBalance}
                      </p>
                      <p className=" font-semibold text-rgbaprimary7">
                        AEPS Wallet Balance
                      </p>
                    </div>
                  </div>
                )}
              {profiledetail.member_type !== "State Head" && (
                <div
                  className="rounded-md  flex items-center"
                  onClick={() => {
                    setOpen(true);
                    setTranferType("commission_wallet");
                  }}
                >
                  <CiWallet className="h-7 w-7 text-rgbaprimary7 font-normal" />
                  <div className="outline-none border-none px-2 text-xs  py-2 rounded-md">
                    <p className=" font-bold text-base text-rgbaprimary7">
                      ₹ {commissionwalletBalance}
                    </p>
                    <p className=" font-semibold text-rgbaprimary7">
                      Commission Wallet Balance
                    </p>
                  </div>
                </div>
              )}
              <Dropdown
                className="dropdownMenu "
                menu={{ items }}
                trigger={["click"]}
              >
                <div className="md:flex sm:flex justify-around hidden  items-center w-36 cursor-pointer hover:bg-white h-11 rounded-full bg-white">
                  <div className="bg-rgbaprimary8 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                    {(profiledetail?.first_name?.[0] || "").toUpperCase()}
                    {(profiledetail?.last_name?.[0] || "").toUpperCase()}
                  </div>

                  <div className="leading-5">
                    <p className="text-rgbaprimary7 font-bold">
                      <span className="capitalize">
                        {trimString(profiledetail.first_name, 6)}{" "}
                        {trimString(profiledetail.last_name, 6)}
                      </span>
                    </p>
                  </div>
                  <IoIosArrowDown />
                </div>
              </Dropdown>
              <Modal
                title={`Add Funds to Main Wallet`}
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
              >
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={(val) => handleTransfer(val)}
                >
                  <Form.Item
                    label="Amount"
                    name="amount"
                    rules={[
                      { required: true, message: "Please enter an amount" },
                    ]}
                  >
                    <Input placeholder="Enter amount" />
                  </Form.Item>
                  {/* <Form.Item
                    label="Transfer From"
                    name="transfer_from"
                    rules={[{ required: true, message: "Please enter an pin" }]}
                  >
                    <Select
                      options={[
                        { label: "AEPS Wallet ", value: "aeps_wallet" },
                        {
                          label: "Commission Wallet",
                          value: "commission_wallet",
                        },
                      ]}
                      placeholder="Select Wallet Type"
                    />
                  </Form.Item> */}
                  <Form.Item
                    label="Pin"
                    name="pin"
                    rules={[{ required: true, message: "Please enter an pin" }]}
                  >
                    <Input placeholder="Enter pin" />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      htmlType="submit"
                      loading={BtnLoading}
                      className="w-full mt-4 "
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </Modal>
            </div>
          </Header>
          <Content
            className={`bg-[#fdf7ec] h-full p-3 ${
              collapsed ? "ml-[75px]" : "ml-[230px]"
            }`}
          >
            <div className="flex items-center mb-3">
              <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 text-white bg-primary px-3 py-1 rounded-md hover:opacity-80"
              >
                <ArrowLeftOutlined />
                <span>Go Back</span>
              </button>
            </div>
            {news?.length !== 0 && (
              <div className="bg-primary rounded-sm w-full mb-5 ">
                <Marquee pauseOnHover={true} speed={50}>
                  <p>&nbsp; &nbsp;</p>
                  {news?.map((i, index) => {
                    return (
                      <p
                        key={0}
                        className="py-1  rounded-md text-white  text-[17px]"
                      >
                        &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{index + 1}.{" "}
                        <span className="capitalize font-bold">{i.title}</span>:{" "}
                        <span className="">{i.description}</span>
                      </p>
                    );
                  })}
                </Marquee>
              </div>
            )}

            {children}
          </Content>
        </Layout>
      </Layout>
      {openDrawer && (
        <NotificationDrawer setopen={setOpenDrawer} open={openDrawer} />
      )}
      {openReVerifyPin && (
        <Modal
          maskClosable={false}
          closable={false}
          keyboard={false}
          title={"Enter M-Pin"}
          footer={null}
          className="shadow-normal"
          width={300}
          open={openReVerifyPin}
          // onCancel={() => setOpenReVerifyPin(false)}
        >
          <div className="  rounded-3xl shadow-normal bg-white ">
            <>
              <div className="header flex flex-col justify-center items-center">
                <p className="text-[15px] mt-3 text-gray-500">Enter Pin</p>
              </div>
              <div className=" mt-5 flex justify-center items-center">
                {[1, 2, 3, 4].map((i, index) => {
                  return (
                    <>
                      <input
                        key={index}
                        ref={inputRefs[index]}
                        type="text"
                        maxLength={1}
                        className="w-[15px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb rounded-md bg-gray-300 h-8  mx-1 border-none focus:outline-none focus:border-none text-center"
                        value={pin[index]}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyUp={(e) => handleKeyUp(index, e)}
                      />
                    </>
                  );
                })}
              </div>
              <Button
                loading={modalLoading}
                onClick={() => pin.length === 4 && handleVerify()}
                className={`SignInBtn w-full ${
                  pin.length === 4 ? "cursor-pointer" : "cursor-not-allowed"
                }  mt-4 ${
                  pin.length === 4 ? "bg-primary" : "bg-bsgray"
                }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
              >
                <p>Verify Pin</p>
              </Button>
            </>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ProjectLayout;
